import reducerConstant from 'common/reducerConstants';

export function profileRequest() {
  return {
    type: reducerConstant.profileRequest,
  };
}
export function profileSuccess(obj) {
  return {
    type: reducerConstant.profileSuccess,
    payload: {
      ...obj,
    },
  };
}
export function profileFailed(obj) {
  return {
    type: reducerConstant.profileFailed,
    payload: {
      ...obj,
    },
  };
}

export function updateProfile(obj) {
  return {
    type: reducerConstant.updateProfile,
    payload: {
      ...obj,
    },
  };
}
export function updateProfileSuccess(obj) {
  return {
    type: reducerConstant.updateProfileSuccess,
    payload: {
      ...obj,
    },
  };
}
export function updateProfileFailed(obj) {
  return {
    type: reducerConstant.updateProfileFailed,
    payload: {
      ...obj,
    },
  };
}
export function generateSignedUrl(obj) {
  return {
    type: reducerConstant.generateSignedUrl,
    payload: {
      ...obj,
    },
  };
}
export function generateSignedUrlError(obj) {
  return {
    type: reducerConstant.generateSignedUrlError,
    payload: {
      ...obj,
    },
  };
}
export function resetData() {
  return {
    type: reducerConstant.profileReset,
  };
}

export function regenerateKey() {
  return { type: reducerConstant.regenerateKey };
}
